import React, { useState } from 'react'
import { Row, Col, Card } from 'antd'
import { translate } from 'react-i18next'

import RecordDetail from './RecordDetail'
import RecordPagination from './RecordPagination'

const perPage = 10

const RecordInfo = ({t, keycloak, language}) => {
    const [pagination, setPagination] = useState({page: 1, perPage});
    return (
        <>
            <Row type="flex" justify="center">
                <Col xl={12} lg={14} md={18} sm={22} xs={20}>
                    <Card className="card-record">
                        <Row>
                            <Col span={24} className="card-record-header">
                                <label>{t('my_record.title')}</label>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className="card-record-detail">
                                <RecordDetail keycloak={keycloak} pagination={pagination} language={language} />
                            </Col>
                        </Row>
                    </Card>
                    <Row justify="center">
                        <Col span={24} id="pagination-record">
                            <RecordPagination onSelected={setPagination} />
                        </Col>
                    </Row>
                </Col>
            </Row >
        </>
    )
}

export default translate()(RecordInfo)